import _ from 'lodash';
import Config from '../config/main';
import { fetchRequest } from '../helpers/util/requestMiddleware';


const makeCMSRequest = _.partial(fetchRequest, Config.casino.url);

class CMSApi {
    static get mainParams() {
        return {
            partner_id: Config.main.site_id,
            is_mobile: 1,
            lang: Config.env.lang,
        }
    }

    static getLiveCasinoGames(params = {}) {
        const queryParams = { category: 28, ...CMSApi.mainParams, ...params };
        return makeCMSRequest('getGames', 'GET', { queryParams });
    }

    static getCasinoGames(params = {}) {
        const queryParams = { ...CMSApi.mainParams, ...params };
        return makeCMSRequest('getGames', 'GET', { queryParams });
    }

    static getGroupedProviderOptions(params = {}) {
        const queryParams = { ...CMSApi.mainParams, ...params };
        return makeCMSRequest('getGroupedProviderOptions', 'GET', { queryParams });
    }
};

export default CMSApi;